import React, { useEffect, useState, useRef } from "react";
import HttpService from "../services/httpService";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import { commaSeparateAmount } from './commaSeparate';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  withStyles,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  TablePagination,
  Radio,
  TableContainer,
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from "../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    background: "blue",
  },
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
  submitButton: {
    backgroundColor: "#F47E46 !important", // Decorpot Orange
    color: "white", // White text
    "&:hover": {
      backgroundColor: "#E0663D !important", // Darker Orange on hover
    },
  },
  tableHeaderCell : {
    textAlign: "center",
    fontWeight: 700,
    backgroundColor: "#1C375D",
    color: "white",
  }
}));

const MarketingOnNTBCHold = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [storeDateFilter, setPivotDatefilters] = useState({
    startDate: "",
    endDate: "",
  });
  const [searchInput, setSearchInput] = useState("");
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const [selectedFilterOption, setSelectedFilterOption] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [data, setData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const buttonRef = useRef(null);
  const [leadStatusData, setLeadStatusData] = useState([])
  const searchTypes = [
    "Customer Name",
    "Email ID",
    "Lead No",
    "Project No",
    "Contact No",
    "Unique Lead No",
  ];

  const headers = [
    { key: "serialNo", label: "Sl. No." },
    { key: "_id", label: "Lead Id" },
    { key: "currentStage", label: "Current Stage" },
    { key: "leadType", label: "Lead Type" },
    { key: "leadNumber", label: "Lead No." },
    { key: "leadCreatedDate", label: "Lead Created Date" },
    { key: "projectCode", label: "Project No." },
    { key: "clientName", label: "Client Name" },
    // { key: "clientEmail", label: "Client Email" },
    // { key: "clientNumber", label: "Client Number" },
    { key: "department", label: "Department" },
    { key: "sourceOfLead", label: "Source Of Lead" },
    { key: "expCtrName", label: "Exp. Ctr Name" },
    { key: "cityName", label: "City Name" },
    { key: "salesExecutive", label: "Sales Executive" },
    { key: "asm", label: "ASM" },
    { key: "projectNeeds", label: "SOW" },
    { key: "threeLakhsSuits", label: "Three Lakh Suits" },
    { key: "startProjectBy", label: "Start Project By" },
  ];

  const csvDownloadHandler = async (data) => {
    props.setLoading(true);
    try {
      let csvArray = [];
      for (let i = 0; i < data.length; i++) {
        let obj = {
          serialNo: i + 1,
          _id: data[i]?._id || "NA",
          projectCode: data[i]?.erpProjectNo || "N/A",
          leadNumber: data[i]?.lead_no || "N/A",
          clientName: data[i]?.customerId?.name || "N/A",
          // clientEmail: data[i]?.customerId?.email || "N/A",
          // clientNumber: data[i]?.customerId?.contact_no || "N/A",
          expCtrName: data[i]?.experienceCenterId?.name || "N/A",
          cityName: data[i]?.city?.name || "N/A",
          currentStage: data[i]?.currentStage || "NA",
          leadType: data[i]?.leadType || "NA",
          department: data[i]?.departmentId?.name || "NA",
          sourceOfLead: data[i]?.sourceOfLead?.name || "NA",
          leadCreatedDate: moment(data[i]?.createdAt).format('DD-MM-YYYY') || "NA",
          salesExecutive: data[i]?.salesUser?.name || "NA",
          asm: data[i]?.salesAssistantManager?.name || "NA",
          projectNeeds: data[i]?.projectNeeds || "NA",
          threeLakhsSuits: data[i]?.threeLakhsSuits || "NA",
          startProjectBy: data[i]?.startProjectBy || "NA",
        };

        csvArray.push(obj);
      }
      setCsvData(csvArray);
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const downloadExcel = () => {
    props.setLoading(true)
    try {
      setTimeout(() => {
        buttonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    props.setLoading(false)
  }

  useEffect(() => {
    getOnNTBCHoldMarketingData();
  }, []);

  const storePivotDate = (e) => {
    const { name, value } = e.target;
    setPivotDatefilters({ ...storeDateFilter, [name]: value });
  };

  //handle search ribbon
  const handleSearchType = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && selectedSearchType && searchInput) {
      handleSearch(searchInput.toUpperCase());
    }
  };

  const handleSearch = async (value) => {
    getOnNTBCHoldMarketingData(
      selectedSearchType,
      searchInput
    );
  };

  // handle submit button
  const handleSubmitButton = () => {
    getOnNTBCHoldMarketingData();
  };

  //clear filter function
  const clearDateFilter = () => {
    setSearchInput("");
    setSelectedSearchType("");
    setPivotDatefilters({
      startDate: "",
      endDate: "",
    });
    getOnNTBCHoldMarketingData();
  };


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // getOnNTBCHoldMarketingData main data function
  const getOnNTBCHoldMarketingData = async (selectedSearchType, searchInput) => {
    props.setLoading(true);
    try {
      let obj = {
        startDate: storeDateFilter.startDate,
        endDate: storeDateFilter.endDate,
        dateFilterType: selectedFilterOption,
        experienceCenterId: userDetails.experienceCenterId,
        searchType: selectedSearchType ? selectedSearchType : "",
        search: searchInput ? searchInput.toUpperCase() : "",
      }
      let response = await HttpService.getOnNTBCHoldMarketingData(obj);
      setData(response?.data);
      setLeadStatusData(response.data)
    }
    catch (err) {
      props.setSnackInfo('Something went wrong', 'error');
      console.error(err);
    }
    props.setLoading(false)
  }

  return (
    <div className="App">
      <div>
        <div>
          <h3 style={{ textAlign: "center", marginBottom: "15px" }}>
            {" "}Status - On NTBC - Hold{" "}
          </h3>
          <Paper className={classes.paper}>
            <Grid
              container
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
              <>
                <Grid item xs={12} sm={3}>
                  <TextField
                    id="startDate"
                    name="startDate"
                    label="From Created Date"
                    type="date"
                    variant="outlined"
                    value={storeDateFilter.startDate}
                    onChange={storePivotDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    id="endDate"
                    name="endDate"
                    label="End Created Date"
                    type="date"
                    variant="outlined"
                    value={storeDateFilter.endDate}
                    onChange={storePivotDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitButton}
                    style={{
                      backgroundColor: "#F50057",
                      color: "#fff",
                      padding: "0.4rem 2rem 2rem 2rem",
                    }}
                    className={classes.submitButton}
                  >
                    Submit
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => csvDownloadHandler(data)}
                    style={{
                      backgroundColor: "#355025",
                      color: "#FFF2EB",
                      padding: "0.4rem 2rem 2rem 2rem",
                    }}
                  >
                    Download Excel
                  </Button>
                  <CSVLink
                    headers={headers}
                    filename={'OnNTBCHoldData.csv'}
                    data={csvData}
                    ref={buttonRef}
                  />
                </Grid>
              </>
            </Grid>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "30px",
              }}
            >
              {/* Search Type Dropdown */}
              <TextField
                select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedSearchType}
                label="Search Type"
                name="searchType"
                onChange={(e) => handleSearchType(e.target.value)}
                variant="outlined"
                style={{ width: "30%", marginRight: "2%" }}
                size="small"
              >
                {searchTypes &&
                  searchTypes?.map((el, index) => (
                    <MenuItem key={index} value={el}>
                      {el}
                    </MenuItem>
                  ))}
              </TextField>

              {/* Search Input */}
              <TextField
                label="Enter the input"
                name="searched"
                size="small"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
                onKeyDown={handleKeyDown}
                variant="outlined"
                style={{ width: "80%" }}
              />

              {/* Search Button */}
              <Button
                disabled={!selectedSearchType || !searchInput}
                variant="contained"
                color="primary"
                size="medium"
                style={{ alignSelf: "center", marginLeft: 20 }}
                className={classes.leadSearchButton}
                onClick={() => handleSearch(searchInput.toUpperCase())}
              >
                Search
              </Button>

              {/* Clear Filter Button */}
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                style={{ marginLeft: 10 }}
                className={classes.leadClearButton}
                onClick={clearDateFilter}
              >
                Clear Filter
              </Button>
            </div>
          </Paper>
        </div>
        <br />
        <div>
          <Paper>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', alignItems: 'right' }}>
              <TablePagination
                rowsPerPageOptions={[20, 50, 100, 200, 500, { label: 'All', value: leadStatusData?.length }]}
                colSpan={14}
                count={leadStatusData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{ flexShrink: 0 }}
              />
            </div>
        
          <TableContainer component={Paper}>
            <Table
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell className={classes.tableHeaderCell}> Sl No. </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Customer </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Lead No </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Project No. </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Current Stage </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Email </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Mobile </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Address  </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Area </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Lead Type </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Assigned to </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Quotation Amount </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Created At </TableCell>
                  <TableCell className={classes.tableHeaderCell}> Expected Closure Date </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.length !== 0 ? (
                  data
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.sort((a, b) =>
                      b.createdAt
                        .split("-")
                        .reverse()
                        .join()
                        .localeCompare(a.createdAt.split("-").reverse().join())
                    )
                    ?.map((row, i) => {
                      return (
                        <TableRow key={i + 1}>
                            <TableCell>{i + 1}</TableCell>
                            <TableCell component="th" scope="row">
                              {row?.customerId?.name}
                            </TableCell>
                            <TableCell component="th">
                              <Link
                                target="_blank"
                                to={`/project-logs/${row?._id}`}
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                }}
                              >
                                {row?.lead_no}
                              </Link>
                            </TableCell>
                            <TableCell component="th"> {row?.erpProjectNo ? row?.erpProjectNo : '-'} </TableCell>
                            <TableCell component="th"> {row?.currentStage} </TableCell>
                            <TableCell component="th"> {row?.customerId?.email} </TableCell>
                            <TableCell component="th"> {row?.customerId?.contact_no} </TableCell>
                            <TableCell component="th"> {row?.customerId?.address} </TableCell>
                            <TableCell component="th"> {row?.area} </TableCell>
                            <TableCell component="th"> {row?.leadType} </TableCell>
                            <TableCell component="th"> {row?.assignTo?.name} </TableCell>
                            <TableCell component="th"> ₹ {row?.grandTotal ? commaSeparateAmount(row.grandTotal) : '0.00'} </TableCell>
                            <TableCell component="th"> {row?.createdAt ? moment(row?.createdAt).format('DD-MM-YYYY') : 'NA'} </TableCell>
                            <TableCell component="th"> {row?.expectedSalesclosureDate ? moment(row?.expectedSalesclosureDate).format('DD-MM-YYYY') : 'NA'} </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell colSpan={14} style={{ textAlign: "center" }}>
                      No Records Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          </Paper>
        </div>
      </div>
      {/* modal */}
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(MarketingOnNTBCHold);
